import React from 'react'
import { Page } from '../shared/ui/Page'
import { t } from '../../config/i18n'

export const PageHome = () => (
  <Page title={t.nav.main}>
  </Page>
)
